<template>
    <Slide :title="title" :subtitle="subtitle">
        <div>
            <p class="cr:text-sm cr:font-semibold cr:mb-1">Personal:</p>
            <div class="cr:grid cr:grid-cols-2 cr:md:grid-cols-3 cr:text-sm cr:ml-3">
                <div v-for="leadType in leadTypes.filter(type => type.type === 'personal')" class="cr:flex cr:items-center cr:gap-2 cr:p-1 cr:my-1">
                    <CustomCheckbox v-model="leadType.selected"/>
                    <p>{{ leadType.name }}</p>
                </div>
            </div>
            <p class="cr:text-sm cr:font-semibold cr:mb-1 cr:mt-3">Business:</p>
            <div class="cr:grid cr:grid-cols-2 cr:md:grid-cols-3 cr:text-sm cr:ml-3">
                <div v-for="leadType in leadTypes.filter(type => type.type === 'business')" class="cr:flex cr:items-center cr:gap-2 cr:p-1 cr:my-1">
                    <CustomCheckbox v-model="leadType.selected"/>
                    <p>{{ leadType.name }}</p>
                </div>
            </div>
        </div>
    </Slide>
</template>

<script setup lang="ts">

import CustomCheckbox from "@/components/elements/CustomCheckbox.vue";
import {ref, computed} from "vue";
import Slide from "@/components/slides/Slide.vue";
import {useErrorStore} from "@/stores/error.ts";

const leadTypes = ref([
    {name: 'Auto', selected: false, type: 'personal'},
    {name: 'Home', selected: false, type: 'personal'},
    {name: 'Renters', selected: false, type: 'personal'},
    {name: 'Life', selected: false, type: 'personal'},
    {name: 'Speciality Vehicle', selected: false, type: 'personal'},
    {name: 'Umbrella Personal Liability', selected: false, type: 'personal'},
    {name: 'Business Insurance', selected: false, type: 'business'},
    {name: 'Group Health', selected: false, type: 'business'},
    {name: 'Commercial Auto', selected: false, type: 'business'},
    {name: 'Cyber Insurance', selected: false, type: 'business'},
]);

const errorStore = useErrorStore();

const props = defineProps({
    title: {
        type: String,
        default: 'What services do you offer?'
    },
    subtitle: {
        type: String,
        default: 'Select all that apply.'
    }
});

const slidePayload = computed(() => {
    return {
        lead_types: leadTypes.value.filter(type => type.selected).map(type => type.name),
    }
});
const validate = () => {
    if (leadTypes.value.filter(type => type.selected).length < 1) {
        errorStore.report('Please select at least one lead type.')
        return false;
    }

    return true;
}
const canContinue = computed(() => true);

defineExpose({
    canContinue,
    slidePayload,
    validate
});
</script>